import { QueueCondition } from 'src/app/services/api/taskmanagement/taskmanagement.service';
export class QueueConditionObject implements QueueCondition{
    queueConditionId: string;
    field: string;
    operation: string;
    value: string
}